import { getAuthToken } from "@shared/api/Auth.ts";
import { FxIdApplicationCrossPlayHandlersEventRuleDTO } from "@shared/api/gen";
import OpenApiClient from "@shared/api/OpenApiClient.ts";


// Описывает событие, которое приходит от Unity
interface TrackableEvent {
	eventCode: string;
	value: number;
	game: string;
	p1?: string;
	p2?: string;
	p3?: string;
}

export class CrossPromoServiceController {
	// Хранилище правил для фильтрации
	private eventRules: FxIdApplicationCrossPlayHandlersEventRuleDTO[] = [];
	private isInitialized = false;
	private game: string;

	constructor(game: string) {
		this.game = game;
	}

	public async initialize(): Promise<void> {
		if (this.isInitialized) return;
		await this.refreshEventRules();
		this.isInitialized = true;
	}

	/**
	 * Загружает с сервера АКТУАЛЬНЫЙ список правил для фильтрации.
	 */
	public async refreshEventRules(): Promise<void> {
		try {
			this.eventRules = await OpenApiClient.CrossPlay.fxIdWebFeaturesCrossPlayGetEventRulesEndpoint(this.game);
			log.info("Filter rules refreshed:", this.eventRules);
		} catch (error) {
			log.error("Failed to refresh event rules from server:", error);
		}
	}

	/**
	 * Главный метод. Принимает событие от Unity и фильтрует его.
	 */
	public async trackEvent(event: TrackableEvent): Promise<void> {
		if (!this.isInitialized) {
			return;
		}

		if (this.eventRules.length === 0) {
			log.info("No filter rules found, sending event directly:", event);
			await this.sendInGameEvent(event);
			return; // Завершаем выполнение метода
		}

		const matchedRule = this.eventRules.find(rule => this.isRuleMatched(rule, event));

		if (matchedRule) {
			await this.sendInGameEvent(event);
		} else {
			log.warn("[EVENT] Rule not matched")
		}
	}

	/**
	 * Проверяет, соответствует ли событие одному конкретному правилу.
	 * Реализует логику "фильтровать начиная с первого параметра".
	 */
	private isRuleMatched(rule: FxIdApplicationCrossPlayHandlersEventRuleDTO, event: TrackableEvent): boolean {
		if (rule.Code !== event.eventCode) {
			return false;
		}
		return this.isFilterMatch(rule.Filter1, event.p1) &&
			this.isFilterMatch(rule.Filter2, event.p2) &&
			this.isFilterMatch(rule.Filter3, event.p3);
	}

	/**
	 * Проверяет совпадение одного фильтра с поддержкой RegExp.
	 */
	private isFilterMatch(filter: string | null | undefined, value?: string): boolean {
		if (filter === null || filter === undefined || filter === "") {
			return true;
		}
		if (value === undefined) {
			return false;
		}
		if (filter.startsWith("/") && filter.endsWith("/")) {
			try {
				return new RegExp(filter.slice(1, -1)).test(value);
			} catch (e) {
				log.error("Invalid regex in filter:", filter);
				return false;
			}
		}

		return filter === value;
	}

	/**
	 * Отправляет событие на сервер. Этот код был у вас и он корректен.
	 */
	private async sendInGameEvent(event: TrackableEvent): Promise<void> {
		try {
			await OpenApiClient.CrossPlay.fxIdWebFeaturesCrossPlaySendInGameEventEndpoint({
				GameSystemName: event.game,
				EventCode: event.eventCode,
				Value: event.value
			});
		} catch (error) {
			log.error("Failed to send event to server:", error);
		}
	}
}

export const CreateCrossPromoService = (game: string) => new CrossPromoServiceController(game);